import * as React from 'react'
import { TRIPS_HISTORY_COLUMNS } from '../../state/constants/index'
import ListFilterDropdown from '../ui/ListFilterDropdown'
import SearchFilter from '../ui/SearchFilter'

interface ITripsHistoryHeader {
  columns: TRIPS_HISTORY_COLUMNS[]
}

class TripsHistoryHeader extends React.Component<any, ITripsHistoryHeader> {
  public render() {
    return (
      <div className='flex justify-between pl3'>
        <div className='flex col-12'>
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.DATE) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.DATE}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.PICKUP_TIME) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.PICKUP_TIME}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.STATUS) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.STATUS}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.RIDER_NAME) && (
            <div className='col-6'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.RIDER_NAME}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.PROVIDER) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.PROVIDER}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.SERVICE) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.SERVICE}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.COST) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.COST}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
          {this.props.columns.includes(TRIPS_HISTORY_COLUMNS.FARE) && (
            <div className='col-3'>
              <ListFilterDropdown label={TRIPS_HISTORY_COLUMNS.FARE}>
                <SearchFilter
                  placeholder='Find provider'
                  items={[
                    {
                      label: 'United Taxi',
                      value: 'united_taxi'
                    },
                    { label: 'Uber', value: 'uber' },
                    { label: 'Lyft', value: 'lyft' }
                  ]}
                  name='provider_search'
                  selections={['uber']}
                />
              </ListFilterDropdown>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default TripsHistoryHeader



// WEBPACK FOOTER //
// ./src/components/trips/TripsHistoryHeader.tsx